export const HORSESHOE_7_LAYOUT = {
    id: 'horseshoe-7',
    family: 'horseshoe',
    cards: 7,
    description: 'Arco ampio per diagnosi, evoluzione e letture narrative a più stadi.',
    supports_focus_overlay: true,
    variants: [
        {
            id: 'portrait',
            points: [
                { x: 14, y: 62, z: 1 },
                { x: 24, y: 40, z: 1 },
                { x: 38, y: 24, z: 1 },
                { x: 50, y: 18, z: 1 },
                { x: 62, y: 24, z: 1 },
                { x: 76, y: 40, z: 1 },
                { x: 86, y: 62, z: 1 },
            ],
        },
        {
            id: 'compact',
            points: [
                { x: 12, y: 66, z: 1 },
                { x: 24, y: 46, z: 1 },
                { x: 36, y: 30, z: 1 },
                { x: 50, y: 24, z: 1 },
                { x: 64, y: 30, z: 1 },
                { x: 76, y: 46, z: 1 },
                { x: 88, y: 66, z: 1 },
            ],
        },
    ],
};
//# sourceMappingURL=horseshoe-7.js.map